<template>
  <div id="container">
    <!-- 头部 - 固定在顶部 -->
    <div class="reclaimed-water-header">
      <div class="reclaimed-water-header-left">
        <div class="header-left-box1" :class="{ active: productionStatus === 'on' }" @click="productionHandleOnClick">
          生产工况开</div>
        <div class="header-left-box2" @click="productionHandleOffClick" :class="{ active: productionStatus === 'off' }">
          生产工况关</div>
      </div>
      <div class="reclaimed-water-header-center">
        中水系统监控大屏
      </div>
      <div class="reclaimed-water-header-right">
        <!-- <div class="header-right-box1" :class="{
          'status-on': production,
          'status-off': !production
        }" @click="productionHandleClick">生产工开</div>
        <div class="header-right-box2" :class="{
          'status-on': reverse,
          'status-off': !reverse
        }" @click="reverseHandleClick">反冲工况</div> -->
        <div class="header-right-box1" @click="reverseHandleOnClick" :class="{ active: reverseStatus === 'on' }">反冲工况开
        </div>
        <div class="header-right-box2" @click="reverseHandleOffClick" :class="{ active: reverseStatus === 'off' }">反冲工况关
        </div>
      </div>
    </div>

    <!-- 主体内容区域 -->
    <div class="reclaimed-water-content">
      <div class="absolute-content">
        <!-- 绝对定位内容 -->
        <div v-for="(item, index) in farArr" class="icon-far"
          :style="{ top: item.top, left: item.left, backgroundImage: `url(${item.bgUrl})` }" v-show="item.visible">
        </div>
        <div v-for="(item, index) in farArr1" class="icon-far"
          :style="{ top: item.top, left: item.left, backgroundImage: `url(${item.bgUrl})` }" v-show="item.visible">
        </div>

        <div v-for="(item, index) in policeArr" class="police-box blink-simple" v-show="item.visible"
          :style="{ top: item.top, left: item.left }"></div>


          <div> </div>

        <div v-for="(item, index) in pumpArr" class="water-pump-switch" :class="{ hidden: !item.visible }"
          :style="{ top: item.top, left: item.left }" @click="pumpHandleClick(item)"></div>

        <div v-for="(item, index) in statusArr" :key="'status-' + index" class="status-box" :class="{
          'auto-status': item.isAuto,
          'manual-status': !item.isAuto
        }" :style="{ top: item.top, left: item.left }">
          {{ item.isAuto ? '自动' : '手动' }}
        </div>

        <div v-for="(item, index) in pumpStatusArr" class="pump-status-box" :class="{
          'pump-status-on': item.isAuto,
          'pump-status-off': !item.isAuto
        }" :style="{ top: item.top, left: item.left }">
        </div>

        <div v-for="(item, index) in pumpPoliceArr" class="pump-status-box" :class="{
          'pump-status-police': item.isAuto,
          'pump-status-off': !item.isAuto
        }" :style="{ top: item.top, left: item.left }">
        </div>


        <div v-for="(item, index) in pumpTextArr" :key="'pumpTextArr-' + index" class="status-pump-text" :class="{
          'auto-status': item.isAuto,
          'manual-status': !item.isAuto
        }" :style="{ top: item.top, left: item.left }">
          {{ item.isAuto ? '自动' : '手动' }}
        </div>


        <!-- 电磁流量计   -->
        <div v-for="(item, index) in hydArr" class="hyd-box" :style="{ top: item.top, left: item.left }">
          <span>液位：{{ item.hydValue }}cm</span>
        </div>


        <div v-for="(item, index) in turbidityArr" class="turbidity-box" :style="{ top: item.top, left: item.left }">
          <span>浊度：{{ item.turbidityValue }}mg/l</span>
        </div>

        <div v-for="(item, index) in lcpArr" class="turbidity-box" :style="{ top: item.top, left: item.left }">
          <span>LCP：{{ item.lcpValue }}</span>
        </div>


        <div v-for="(item, index) in trafficArr" class="turbidity-box" :style="{ top: item.top, left: item.left }">
          <span>流量：{{ item.trafficValue }}m³/s</span>
        </div>

        <!-- 水流效果 -->
        <!--  <div v-for="line in lineArr" :key="'line-' + index" class="flow-line" :style="{
          top: line.top,
          left: line.left,
          width: line.length,
          transform: `rotate(${line.rotate}deg)`
        }"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
const CHECK_INTERVAL = 3000; // 3 秒
const MAX_RETRY = 3;        // 最大重试次数
import service from '../../service/leftService.js'
export default {
  name: 'ModelLoader',
  data() {
    return {
      farArr: [
        {
          id: 1,
          top: '414px',
          left: '85px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "1号蓝色阀门状态"
        },
        {
          id: 2,
          top: '463px',
          left: '143px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "1号蓝色阀门状态"
        },
        {
          id: 3,
          top: '414px',
          left: '264px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "3号蓝色阀门状态"
        },
        {
          id: 4,
          top: '463px',
          left: '323px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "3号蓝色阀门状态"
        },
        {
          id: 5,
          top: '414px',
          left: '448px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "5号蓝色阀门状态"
        },
        {
          id: 5,
          top: '464px',
          left: '506px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "5号蓝色阀门状态" // 控制显示隐藏
        },
        {
          id: 5,
          top: '415px',
          left: '628px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "7号蓝色阀门状态"
        },
        {
          id: 5,
          top: '464px',
          left: '687px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "7号蓝色阀门状态" // 控制显示隐藏
        },
        {
          id: 5,
          top: '414px',
          left: '806px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "9号蓝色阀门状态" // 控制显示隐藏
        },
        {
          id: 5,
          top: '463px',
          left: '866px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true, // 控制显示隐藏
          name: "9号蓝色阀门状态" // 控制显示隐藏
        },
        {
          id: 5,
          top: '414px',
          left: '985px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "11号蓝色阀门状态"
        },
        {
          id: 5,
          top: '464px',
          left: '1045px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "11号蓝色阀门状态"
        },
        {
          id: 5,
          top: '414px',
          left: '1169px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "13号蓝色阀门状态"
        },
        {
          id: 5,
          top: '414px',
          left: '1349px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "15号蓝色阀门状态"
        },
        {
          id: 5,
          top: '464px',
          left: '1228px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "13号蓝色阀门状态"
        },
        {
          id: 5,
          top: '464px',
          left: '1408px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "15号蓝色阀门状态"
        },
        {
          id: 5,
          top: '740px',
          left: '85px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "2号蓝色阀门状态"
        },
        {
          id: 5,
          top: '741px',
          left: '264px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "4号蓝色阀门状态"
        },
        {
          id: 5,
          top: '741px',
          left: '448px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "6号蓝色阀门状态"
        },
        {
          id: 5,
          top: '741px',
          left: '628px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "8号蓝色阀门状态"
        },
        {
          id: 5,
          top: '740px',
          left: '806px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "10号蓝色阀门状态"
        },
        {
          id: 5,
          top: '741px',
          left: '985px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "12号蓝色阀门状态"
        },
        {
          id: 5,
          top: '741px',
          left: '1169px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "14号蓝色阀门状态"
        },
        {
          id: 5,
          top: '741px',
          left: '1348px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "16号蓝色阀门状态"
        },
        {
          id: 5,
          top: '690px',
          left: '142px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "2号蓝色阀门状态"
        },
        {
          id: 5,
          top: '690px',
          left: '321px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "4号蓝色阀门状态"
        },
        {
          id: 5,
          top: '690px',
          left: '504px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "6号蓝色阀门状态"
        },
        {
          id: 5,
          top: '690px',
          left: '684px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "8号蓝色阀门状态"
        },
        {
          id: 5,
          top: '690px',
          left: '863px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "10号蓝色阀门状态"
        },
        {
          id: 5,
          top: '690px',
          left: '1042px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "12号蓝色阀门状态"
        },
        {
          id: 5,
          top: '690px',
          left: '1225px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "14号蓝色阀门状态"
        },
        {
          id: 5,
          top: '690px',
          left: '1406px',
          bgUrl: '../../../static/img/big/lanOpen.png',
          visible: true,
          name: "16号蓝色阀门状态"
        }
      ],
      farArr1: [
        {
          id: 1,
          top: '413px',
          left: '142px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "1号黄色阀门状态"
        }, {
          id: 1,
          top: '414px',
          left: '322px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "3号黄色阀门状态"
        }, {
          id: 1,
          top: '413px',
          left: '505px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "5号黄色阀门状态"
        }, {
          id: 1,
          top: '413px',
          left: '685px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "7号黄色阀门状态"
        }, {
          id: 1,
          top: '413px',
          left: '864px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "9号黄色阀门状态"
        }, {
          id: 1,
          top: '414px',
          left: '1043px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "11号黄色阀门状态"
        }, {
          id: 1,
          top: '414px',
          left: '1227px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "13号黄色阀门状态"
        }, {
          id: 1,
          top: '414px',
          left: '1406px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "15号黄色阀门状态"
        }, {
          id: 1,
          top: '464px',
          left: '86px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "1号黄色阀门状态"
        }, {
          id: 1,
          top: '465px',
          left: '265px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "3号黄色阀门状态"
        }, {
          id: 1,
          top: '465px',
          left: '449px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "5号黄色阀门状态"
        }, {
          id: 1,
          top: '465px',
          left: '629px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "7号黄色阀门状态"
        }, {
          id: 1,
          top: '464px',
          left: '807px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "9号黄色阀门状态"
        }, {
          id: 1,
          top: '465px',
          left: '986px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "11号黄色阀门状态"
        }, {
          id: 1,
          top: '465px',
          left: '1170px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "13号黄色阀门状态"
        }, {
          id: 1,
          top: '465px',
          left: '1350px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "15号黄色阀门状态"
        }, {
          id: 1,
          top: '690px',
          left: '85px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "2号黄色阀门状态"
        }, {
          id: 1,
          top: '691px',
          left: '264px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "4号黄色阀门状态"
        }, {
          id: 1,
          top: '691px',
          left: '448px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "6号黄色阀门状态"
        }, {
          id: 1,
          top: '691px',
          left: '628px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "8号黄色阀门状态"
        }, {
          id: 1,
          top: '690px',
          left: '806px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "10号黄色阀门状态"
        }, {
          id: 1,
          top: '691px',
          left: '985px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "12号黄色阀门状态"
        }, {
          id: 1,
          top: '691px',
          left: '1169px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "14号黄色阀门状态"
        }, {
          id: 1,
          top: '691px',
          left: '1349px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "16号黄色阀门状态"
        }, {
          id: 1,
          top: '740px',
          left: '142px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "2号黄色阀门状态"
        }, {
          id: 1,
          top: '741px',
          left: '322px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "4号黄色阀门状态"
        }, {
          id: 1,
          top: '741px',
          left: '505px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "6号黄色阀门状态"
        }, {
          id: 1,
          top: '741px',
          left: '685px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "8号黄色阀门状态"
        }, {
          id: 1,
          top: '740px',
          left: '864px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "10号黄色阀门状态"
        }, {
          id: 1,
          top: '741px',
          left: '1043px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "12号黄色阀门状态"
        }, {
          id: 1,
          top: '741px',
          left: '1227px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "14号黄色阀门状态"
        }, {
          id: 1,
          top: '741px',
          left: '1407px',
          bgUrl: '../../../static/img/big/chengOpen.png',
          visible: true, // 控制显示隐藏
          name: "16号黄色阀门状态"
        },
      ],
      policeArr: [
        {
          id: 1,
          top: '438px',
          left: '124px',
          visible: true, // 控制显示隐藏
          name: '1号压差报警'
        }, {
          id: 1,
          top: '438px',
          left: '303px',
          visible: true, // 控制显示隐藏
          name: '2号压差报警'
        }, {
          id: 1,
          top: '439px',
          left: '487px',
          visible: true, // 控制显示隐藏
          name: '3号压差报警'
        }, {
          id: 1,
          top: '439px',
          left: '667px',
          visible: true, // 控制显示隐藏
          name: '4号压差报警'
        }, {
          id: 1,
          top: '438px',
          left: '845px',
          visible: true, // 控制显示隐藏
          name: '5号压差报警'
        }, {
          id: 1,
          top: '438px',
          left: '1025px',
          visible: true, // 控制显示隐藏
          name: '6号压差报警'
        }, {
          id: 1,
          top: '439px',
          left: '1209px',
          visible: true, // 控制显示隐藏
          name: '7号压差报警'
        }, {
          id: 1,
          top: '439px',
          left: '1389px',
          visible: true, // 控制显示隐藏
          name: '8号压差报警'
        }, {
          id: 1,
          top: '714px',
          left: '123px',
          visible: true, // 控制显示隐藏
          name: '9号压差报警'
        }, {
          id: 1,
          top: '714px',
          left: '303px',
          visible: true, // 控制显示隐藏
          name: '10号压差报警'
        }, {
          id: 1,
          top: '715px',
          left: '486px',
          visible: true, // 控制显示隐藏
          name: '11号压差报警'
        }, {
          id: 1,
          top: '715px',
          left: '666px',
          visible: true, // 控制显示隐藏
          name: '12号压差报警'
        }, {
          id: 1,
          top: '714px',
          left: '845px',
          visible: true, // 控制显示隐藏
          name: '13号压差报警'
        }, {
          id: 1,
          top: '715px',
          left: '1024px',
          visible: true, // 控制显示隐藏
          name: '14号压差报警'
        }, {
          id: 1,
          top: '715px',
          left: '1208px',
          visible: true, // 控制显示隐藏
          name: '15号压差报警'
        }, {
          id: 1,
          top: '715px',
          left: '1388px',
          visible: true, // 控制显示隐藏
          name: '16号压差报警'
        },
      ],
      pumpArr: [
        {
          id: 1,
          top: '139px',
          left: '268px',
          visible: true, // 控制显示隐藏
          name: "1号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '178px',
          left: '268px',
          visible: true, // 控制显示隐藏
          name: "2号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '217px',
          left: '268px',
          visible: true, // 控制显示隐藏
          name: "3号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '221px',
          left: '873px',
          visible: true, // 控制显示隐藏
          name: "4号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '182px',
          left: '873px',
          visible: true, // 控制显示隐藏
          name: "5号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '143px',
          left: '873px',
          visible: true, // 控制显示隐藏
          name: "6号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '167px',
          left: '1238px',
          visible: true, // 控制显示隐藏
          name: "7号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '206px',
          left: '1238px',
          visible: true, // 控制显示隐藏
          name: "8号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '186px',
          left: '1426px',
          visible: true, // 控制显示隐藏
          name: "9号泵开关",
          dataid: '',
        }, {
          id: 1,
          top: '225px',
          left: '1426px',
          visible: true, // 控制显示隐藏
          name: "10号泵开关",
          dataid: '',
        }
      ],
      statusArr: [
        {
          id: 1,
          top: '365px',
          left: '152px',
          isAuto: true,
          name: '1号阀门手动自动信号'
        }, {
          id: 1,
          top: '365px',
          left: '331px',
          isAuto: true,
          name: '3号阀门手动自动信号'
        }, {
          id: 1,
          top: '365px',
          left: '514px',
          isAuto: true,
          name: '5号阀门手动自动信号'
        }, {
          id: 1,
          top: '365px',
          left: '695px',
          isAuto: true,
          name: '7号阀门手动自动信号'
        }, {
          id: 1,
          top: '365px',
          left: '874px',
          isAuto: true,
          name: '9号阀门手动自动信号'
        }, {
          id: 1,
          top: '365px',
          left: '1052px',
          isAuto: true,
          name: '11号阀门手动自动信号'
        }, {
          id: 1,
          top: '365px',
          left: '1235px',
          isAuto: true,
          name: '13号阀门手动自动信号'
        }, {
          id: 1,
          top: '365px',
          left: '1414px',
          isAuto: true,
          name: '15号阀门手动自动信号'
        },
        {
          id: 1,
          top: '640px',
          left: '152px',
          isAuto: true,
          name: '2号阀门手动自动信号'
        }, {
          id: 1,
          top: '640px',
          left: '331px',
          isAuto: true,
          name: '4号阀门手动自动信号'
        }, {
          id: 1,
          top: '640px',
          left: '514px',
          isAuto: true,
          name: '6号阀门手动自动信号'
        }, {
          id: 1,
          top: '640px',
          left: '695px',
          isAuto: true,
          name: '8号阀门手动自动信号'
        }, {
          id: 1,
          top: '640px',
          left: '874px',
          isAuto: true,
          name: '10号阀门手动自动信号'
        }, {
          id: 1,
          top: '640px',
          left: '1052px',
          isAuto: true,
          name: '12号阀门手动自动信号'
        }, {
          id: 1,
          top: '640px',
          left: '1235px',
          isAuto: true,
          name: '14号阀门手动自动信号'
        }, {
          id: 1,
          top: '640px',
          left: '1414px',
          isAuto: true,
          name: '16号阀门手动自动信号'
        },
      ],
      pumpStatusArr: [
        {
          id: 1,
          top: '140px',
          left: '251px',
          isAuto: true,
          name: '1号泵运行状态'
        }, {
          id: 1,
          top: '178px',
          left: '251px',
          isAuto: true,
          name: '2号泵运行状态'
        }, {
          id: 1,
          top: '220px',
          left: '251px',
          isAuto: true,
          name: '3号泵运行状态'
        }, {
          id: 1,
          top: '144px',
          left: '856px',
          isAuto: true,
          name: '4号泵运行状态'
        }, {
          id: 1,
          top: '183px',
          left: '856px',
          isAuto: true,
          name: '5号泵运行状态'
        }, {
          id: 1,
          top: '223px',
          left: '856px',
          isAuto: true,
          name: '6号泵运行状态'
        }, {
          id: 1,
          top: '167px',
          left: '1214px',
          isAuto: true,
          name: '7号泵运行状态'
        }, {
          id: 1,
          top: '204px',
          left: '1214px',
          isAuto: true,
          name: '8号泵运行状态'
        }, {
          id: 1,
          top: '186px',
          left: '1402px',
          isAuto: true,
          name: '9号泵运行状态'
        }, {
          id: 1,
          top: '226px',
          left: '1402px',
          isAuto: true,
          name: '10号泵运行状态'
        },
      ],
      pumpPoliceArr: [
        {
          id: 1,
          top: '158px',
          left: '251px',
          isAuto: true,
          name: '1号泵故障信号'
        }, {
          id: 1,
          top: '195px',
          left: '251px',
          isAuto: true,
          name: '2号泵故障信号'
        }, {
          id: 1,
          top: '237px',
          left: '251px',
          isAuto: true,
          name: '3号泵故障信号'
        }, {
          id: 1,
          top: '162px',
          left: '856px',
          isAuto: true,
          name: '4号泵故障信号'
        }, {
          id: 1,
          top: '200px',
          left: '856px',
          isAuto: true,
          name: '5号泵故障信号'
        }, {
          id: 1,
          top: '242px',
          left: '856px',
          isAuto: true,
          name: '6号泵故障信号'
        }, {
          id: 1,
          top: '184px',
          left: '1215px',
          isAuto: true,
          name: '7号泵故障信号'
        }, {
          id: 1,
          top: '225px',
          left: '1215px',
          isAuto: true,
          name: '8号泵故障信号'
        }, {
          id: 1,
          top: '205px',
          left: '1402px',
          isAuto: true,
          name: '9号泵故障信号'
        }, {
          id: 1,
          top: '246px',
          left: '1402px',
          isAuto: true,
          name: '10号泵故障信号'
        },
      ],
      pumpTextArr: [
        {
          id: 1,
          top: '136px',
          left: '294px',
          isAuto: true,
          name: '1号泵手动自动信号'
        }, {
          id: 1,
          top: '174px',
          left: '294px',
          isAuto: true,
          name: '2号泵手动自动信号'
        }, {
          id: 1,
          top: '215px',
          left: '294px',
          isAuto: true,
          name: '3号泵手动自动信号'
        }, {
          id: 1,
          top: '139px',
          left: '908px',
          isAuto: true,
          name: '4号泵手动自动信号'
        }, {
          id: 1,
          top: '178px',
          left: '908px',
          isAuto: true,
          name: '5号泵手动自动信号'
        }, {
          id: 1,
          top: '218px',
          left: '908px',
          isAuto: true,
          name: '6号泵手动自动信号'
        }, {
          id: 1,
          top: '162px',
          left: '1275px',
          isAuto: true,
          name: '7号泵手动自动信号'
        }, {
          id: 1,
          top: '199px',
          left: '1275px',
          isAuto: true,
          name: '8号泵手动自动信号'
        }, {
          id: 1,
          top: '183px',
          left: '1456px',
          isAuto: true,
          name: '9号泵手动自动信号'
        }, {
          id: 1,
          top: '221px',
          left: '1456px',
          isAuto: true,
          name: '10号泵手动自动信号'
        },
      ],
      hydArr: [{
        id: 1,
        top: '180px',
        left: '113px',
        hydValue: "10",
        name: '1号液位'
      }, {
        id: 1,
        top: '164px',
        left: '717px',
        hydValue: "0",
        name: '2号液位'
      }, {
        id: 1,
        top: '144px',
        left: '1069px',
        hydValue: "0",
        name: '3号液位'
      },],
      turbidityArr: [
        {
          id: 1,
          top: '186px',
          left: '717px',
          turbidityValue: "3",
          name: '1号浊度仪'
        }, {
          id: 1,
          top: '171px',
          left: '1069px',
          turbidityValue: "3",
          name: '2号浊度仪'
        },
      ],
      lcpArr: [
        {
          id: 1,
          top: '206px',
          left: '717px',
          lcpValue: "3",
          name: '1号LCP'
        }, {
          id: 1,
          top: '196px',
          left: '1069px',
          lcpValue: "3",
          name: '2号LCP'
        },
      ],
      trafficArr: [
        {
          id: 1,
          top: '168px',
          left: '352px',
          trafficValue: "3",
          name: '1号流量'
        },
        {
          id: 1,
          top: '171px',
          left: '954px',
          trafficValue: "3",
          name: '2号流量'
        },
      ], // 流量
      production: true,
      reverse: false,
      loading: null,
      timer: null,
      lineArr: [
        {
          id: 1,
          top: '200px',
          left: '100px',
          length: '300px',
          rotate: 0
        },
        {
          id: 2,
          top: '300px',
          left: '400px',
          length: '200px',
          rotate: 45
        },
        {
          id: 3,
          top: '500px',
          left: '200px',
          length: '350px',
          rotate: -90
        }
      ],
      productionStatus: 'none',
      reverseStatus: 'none',
      blueArrOn: [],
      blueArrOff: [],
      yellowArrOn: [],
      yellowArrOff: [],
    };
  },
  mounted() {
    this.productionHandleClick();
    this.getAllData();
  },
  methods: {
    productionHandleClick() {
      this.getBlueData();
      this.getYellowData();
      this.getPressureData();
      this.getStatusArrData();
      this.getPupmStatusData();
      this.getPupmStartData();
      this.getPupmPoliceData();
      // 泵的开关数据
      this.getPupmswitchData();
      this.getLiquidData();
      this.getLcpData();
      this.getTurbidityData();
      this.getTrafficData();
      /* if (this.reverse) {
        this.$message.warning('请先关闭反冲工况');
        return;
      } else {
        this.production = !this.production;
        this.farArr.forEach(item => {
          item.visible = this.production;
        });
      } */
    },
    reverseHandleClick() {
      if (this.production) {
        this.$message.warning('请先关闭生产工况');
        return;
      } else {
        this.reverse = !this.reverse;
        this.farArr1.forEach(item => {
          item.visible = this.reverse;
        });
      }
    },
    pumpHandleClick(item) {
      let that = this;
      this.$confirm('是否执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let obj = {
          id: item.dataid,
          value: item.visible ? '0' : '1',
        }
        service.updatePhysicalPoint(obj).then(res => {
          this.$Message.success("修改成功")
          setTimeout(() => {
            that.getPupmswitchData();
          }, 2000);
        }).catch(err => {
          /* this.$Message.error("修改失败") */
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    getBlueData() {
      let idTwo = { args: ['蓝色阀门状态'] }
      service.getPublicData(idTwo).then(res => {
        this.syncFarArrVisible(res);
        this.handleProductionStatus(res);
      });
    },
    getYellowData() {
      let idTwo = { args: ['黄色阀门状态'] }
      service.getPublicData(idTwo).then(res => {
        this.syncFarArr1Visible(res);
        this.handleReverseStatus(res);
      });
    },
    getPressureData() {
      let arr = { args: ['压差报警数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncPoliceArrVisible(res);
      });
    },
    getStatusArrData() {
      let arr = { args: ['阀门手动自动状态数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncStatusArrVisible(res);
      });
    },
    getPupmStatusData() {
      let arr = { args: ['泵手动自动状态数据'] }
      service.getPublicData(arr).then(res => {
        this.syncPumpStatusArrVisible(res);
      });
    },
    getPupmStartData() {
      let arr = { args: ['泵运行状态数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncPumpStartArrVisible(res);
      });
    },
    getPupmPoliceData() {
      let arr = { args: ['泵故障状态数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncPumpPoliceArrVisible(res);
      });
    },
    getPupmswitchData() {
      let arr = { args: ['泵开关数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncPumpSwitchArrVisible(res);
      });
    },
    getLiquidData() {
      let arr = { args: ['液位数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncHydArr(res);
      });
    },
    getLcpData() {
      let arr = { args: ['LCP数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncLcpArr(res);
      });
    },
    getTurbidityData() {
      let arr = { args: ['浊度数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncTurbidityArr(res);
      });
    },
    getTrafficData() {
      let arr = { args: ['流量数据接口'] }
      service.getPublicData(arr).then(res => {
        this.syncTrafficArr(res);
      });
    },
    // 蓝色阀门开的状态
    async getBlueStatusOnData() {
      let idTwo = { args: ['蓝色阀门开数据接口'] };
      const res = await service.getPublicData(idTwo);
      this.blueArrOn = res;
      return this.isAllZero(res);
    },
    // 蓝色阀门开关的状态
    async getBlueStatusOffData() {
      let idTwo = { args: ['蓝色阀门关数据接口'] }
      const res = await service.getPublicData(idTwo);
      this.blueArrOff = res;
      return this.isAllZero(res);
    },
    // 黄色阀门开的状态
    async getYellowStatusOnData() {
      let idTwo = { args: ['黄色阀门开数据接口'] }
      const res = await service.getPublicData(idTwo);
      this.yellowArrOn = res;
      return this.isAllZero(res);
    },
    // 黄色阀门关的状态
    async getYellowStatusOffData() {
      let idTwo = { args: ['黄色阀门关数据接口'] }
      const res = await service.getPublicData(idTwo);
      this.yellowArrOff = res;
      return this.isAllZero(res);
    },
    // 蓝色泵同步
    syncFarArrVisible(apiArr) {
      // 1. 把后台数组转成 Map：key = secondName
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });

      // 2. 遍历 farArr，按 name 匹配
      this.farArr.forEach(farItem => {
        if (apiMap.hasOwnProperty(farItem.name)) {
          // 注意 value 是字符串 "0"
          farItem.visible = apiMap[farItem.name] !== '0';
        }
      });
    },
    // 黄色泵同步
    syncFarArr1Visible(apiArr) {
      // 1. 把后台数组转成 Map：key = secondName
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });

      // 2. 遍历 farArr，按 name 匹配
      this.farArr1.forEach(farItem => {
        if (apiMap.hasOwnProperty(farItem.name)) {
          // 注意 value 是字符串 "0"
          farItem.visible = apiMap[farItem.name] !== '0';
        }
      });
    },
    // 压差报警同步
    syncPoliceArrVisible(apiArr) {
      // 1. 把后台数组转成 Map：key = secondName
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });
      // 2. 遍历 policeArr，按 name 匹配
      this.policeArr.forEach(policeItem => {
        if (apiMap.hasOwnProperty(policeItem.name)) {
          // 注意 value 是字符串 "0"
          policeItem.visible = apiMap[policeItem.name] !== '0';
        }
      });
    },
    // 阀门手动自动状态同步
    syncStatusArrVisible(apiArr) {
      // 1. 把后台数组转成 Map：key = secondName
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });
      // 2. 遍历 policeArr，按 name 匹配
      this.statusArr.forEach(policeItem => {
        if (apiMap.hasOwnProperty(policeItem.name)) {
          // 注意 value 是字符串 "0"
          policeItem.isAuto = apiMap[policeItem.name] !== '0';
        }
      });
    },
    // 泵手动自动状态同步
    syncPumpStatusArrVisible(apiArr) {
      // 1. 把后台数组转成 Map：key = secondName
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });
      // 2. 遍历 pumpTextArr，按 name 匹配
      this.pumpTextArr.forEach(policeItem => {
        if (apiMap.hasOwnProperty(policeItem.name)) {
          // 注意 value 是字符串 "0"
          policeItem.isAuto = apiMap[policeItem.name] !== '0';
        }
      });
    },
    // 泵运行状态同步
    syncPumpStartArrVisible(apiArr) {
      // 1. 把后台数组转成 Map：key = secondName
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });
      // 2. 遍历pumpStatusArr，按 name 匹配
      this.pumpStatusArr.forEach(policeItem => {
        if (apiMap.hasOwnProperty(policeItem.name)) {
          // 注意 value 是字符串 "0"
          policeItem.isAuto = apiMap[policeItem.name] !== '0';
        }
      });
    },
    // 泵压差报警同步
    syncPumpPoliceArrVisible(apiArr) {
      // 1. 把后台数组转成 Map：key = secondName
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });
      // 2. pumpPoliceArr name 匹配
      this.pumpPoliceArr.forEach(policeItem => {
        if (apiMap.hasOwnProperty(policeItem.name)) {
          // 注意 value 是字符串 "0"
          policeItem.isAuto = apiMap[policeItem.name] !== '0';
        }
      });
    },
    // 泵开关状态同步
    syncPumpSwitchArrVisible(apiArr) {
      // 1. 后台数据转 Map
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = {
          value: item.value,
          id: item.id
        };
      });
      // 2. 同步 pumpArr
      this.pumpArr.forEach(pumpItem => {
        if (apiMap.hasOwnProperty(pumpItem.name)) {
          const apiItem = apiMap[pumpItem.name];
          // 控制显示隐藏
          pumpItem.visible = apiItem.value !== '0';
          // 赋值后台 id
          pumpItem.dataid = apiItem.id;
        }
      });
    },
    // 延时函数
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    // 批量更新接口
    async updateBatch(apiArr, value, interval = 1000) {
      for (const item of apiArr) {
        const obj = {
          id: item.id,
          value: value
        };

        try {
          await service.updatePhysicalPoint(obj);
        } catch (e) {
          console.error('下发失败：', item.id, e);
          // 这里可以选择 continue 或 throw
        }
        // 间隔一段时间再发下一个
        await this.sleep(interval);
      }
    },
    // 主要批量控制
    async handleBatchControl(apiArr) {
      try {

        // 第一次：value = 1
        await this.updateBatch(apiArr, 1);
        /* this.$Message.success("全部开启成功"); */

        // 40 秒后再执行 value = 0
        setTimeout(async () => {
          try {
            await this.updateBatch(apiArr, 0);
            /* this.$Message.success("全部关闭成功"); */
            this.loading.close();
          } catch (err) {
            /* this.$Message.error("关闭失败"); */
            this.loading.close();
          }
        }, 40000);
      } catch (err) {
        this.$Message.error("开启失败");
        this.loading.close();
      }
    },
    // 生产工况开
    async productionHandleOnClick() {
      const a = await this.getBlueStatusOnData();
      if (a) {
        let arr = { args: ['蓝色阀门开数据接口'] }
        service.getPublicData(arr).then(res => {
          this.loading = this.$loading({
            lock: true,
            text: '中水生产工况相关阀组开启中(约40秒)，请保持当前界面不要关闭，禁止进行其它操作，请耐心等待！',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.handleBatchControl(res)
          // 我3秒后重复再开一次
          setTimeout(async () => {
            await this.updateBatch(res, 1);
          }, 3000);
          // 我45秒后在检查一次时候都为0
          setTimeout(async () => {
            const b = await this.getBlueStatusOnData();
            if (!b) {
              await this.updateBatch(res, 0);
            }
          }, 45000);
        });
      } else {
        this.updateBatch(this.blueArrOn, 0);
        this.$Message.warning("存在阀门未关闭情况，系统正在自动关闭中，请稍后再试！");
      }
    },
    // 反冲工况开
    async reverseHandleOnClick() {
      const a = await this.getYellowStatusOnData();
      if (a) {

        let arr = { args: ['黄色阀门开数据接口'] }
        service.getPublicData(arr).then(res => {
          this.loading = this.$loading({
            lock: true,
            text: '中水反冲工况相关阀组开启中(约40秒)，请保持当前界面不要关闭，禁止进行其它操作，请耐心等待！',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.handleBatchControl(res)
          // 我3秒后重复再开一次
          setTimeout(async () => {
            await this.updateBatch(res, 1);
          }, 3000);
          // 我45秒后在检查一次时候都为0
          setTimeout(async () => {
            const b = await this.getYellowStatusOnData();
            if (!b) {
              await this.updateBatch(res, 0);
            }
          }, 45000);
        });
      } else {
        this.updateBatch(this.yellowArrOn, 0);
        this.$Message.warning("存在阀门未关闭情况，系统正在自动关闭中，请稍后再试！");
      }
    },
    // 生产工况关
    async productionHandleOffClick() {
      const a = await this.getBlueStatusOffData();
      if (a) {
        let arr = { args: ['蓝色阀门关数据接口'] }
        service.getPublicData(arr).then(res => {
          this.loading = this.$loading({
            lock: true,
            text: '中水生产工况相关阀组关闭中(约40秒)，请保持当前界面不要关闭，禁止进行其它操作，请耐心等待！',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.handleBatchControl(res)
        });
        // 我3秒后重复再开一次
        setTimeout(async () => {
          await this.updateBatch(res, 1);
        }, 3000);
        // 我45秒后在检查一次时候都为0
        setTimeout(async () => {
          const b = await this.getBlueStatusOffData();
          if (!b) {
            await this.updateBatch(res, 0);
          }
        }, 45000);

      } else {
        this.updateBatch(this.blueArrOff, 0);
        this.$Message.warning("存在阀门未关闭情况，系统正在自动关闭中，请稍后再试！");
      }
    },
    // 反冲工况关
    async reverseHandleOffClick() {
      const a = await this.getYellowStatusOffData();
      if (a) {
        let arr = { args: ['黄色阀门关数据接口'] }
        service.getPublicData(arr).then(res => {
          this.loading = this.$loading({
            lock: true,
            text: '中水反冲工况相关阀组关闭中(约40秒)，请保持当前界面不要关闭，禁止进行其它操作，请耐心等待！',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.handleBatchControl(res)

          // 我3秒后重复再开一次
          setTimeout(async () => {
            await this.updateBatch(res, 1);
          }, 3000);
          // 我45秒后在检查一次时候都为0
          setTimeout(async () => {
            const b = await this.getYellowStatusOffData();
            if (!b) {
              await this.updateBatch(res, 0);
            }
          }, 45000);
        });
      } else {
        this.updateBatch(this.yellowArrOff, 0);
        this.$Message.warning("存在阀门未关闭情况，系统正在自动关闭中，请稍后再试！");
      }
    },
    // 液位赋值
    syncHydArr(apiArr) {
      // 1. 后台数组转 Map
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });

      // 2. 同步 hydArr
      this.hydArr.forEach(hydItem => {
        if (apiMap.hasOwnProperty(hydItem.name)) {
          hydItem.hydValue = apiMap[hydItem.name];
        }
      });
    },
    // LCP赋值
    syncLcpArr(apiArr) {
      // 1. 后台数组转 Map
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });
      // 2. 同步 hydArr
      this.lcpArr.forEach(hydItem => {
        if (apiMap.hasOwnProperty(hydItem.name)) {
          hydItem.lcpValue = apiMap[hydItem.name];
        }
      });
    },
    syncTrafficArr(apiArr) {
      // 1. 后台数组转 Map
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });

      // 2. 同步 trafficArr
      this.trafficArr.forEach(trafficItem => {
        if (apiMap.hasOwnProperty(trafficItem.name)) {
          trafficItem.trafficValue = apiMap[trafficItem.name];
        }
      });
    },
    syncTurbidityArr(apiArr) {
      // 1. 后台数组转 Map
      const apiMap = {};
      apiArr.forEach(item => {
        apiMap[item.secondName] = item.value;
      });

      // 2. 同步 hydArr
      this.turbidityArr.forEach(hydItem => {
        if (apiMap.hasOwnProperty(hydItem.name)) {
          hydItem.turbidityValue = apiMap[hydItem.name];
        }
      });
    },
    getAllData() {
      if (this.timer) return; // 防止重复开启
      this.timer = setInterval(() => {
        this.getBlueData();
        this.getYellowData();
        this.getPressureData();
        this.getStatusArrData();
        this.getPupmStatusData();
        this.getPupmStartData();
        this.getPupmPoliceData();
        // 泵的开关数据
        this.getPupmswitchData();
        this.getLiquidData();
        this.getLcpData();
        this.getTurbidityData();
        this.getTrafficData();
      }, 5000);
    },
    // 生产工况判断
    handleProductionStatus(arr) {
      if (!Array.isArray(arr) || arr.length === 0) {
        this.productionStatus = 'mix';
        return;
      }
      let hasOne = false;
      let hasZero = false;
      arr.forEach(item => {
        if (item.value === '1') hasOne = true;
        if (item.value === '0') hasZero = true;
      });
      if (hasOne && !hasZero) {
        // 全是 1
        this.productionStatus = 'on';
      } else if (!hasOne && hasZero) {
        // 全是 0
        this.productionStatus = 'off';
      } else {
        // 混合
        this.productionStatus = 'mix';
      }
    },
    // 反冲工况判断
    handleReverseStatus(arr) {
      if (!Array.isArray(arr) || arr.length === 0) {
        this.reverseStatus = 'mix';
        return;
      }
      let hasOne = false;
      let hasZero = false;
      arr.forEach(item => {
        if (item.value === '1') hasOne = true;
        if (item.value === '0') hasZero = true;
      });
      if (hasOne && !hasZero) {
        // 全是 1
        this.reverseStatus = 'on';
      } else if (!hasOne && hasZero) {
        // 全是 0
        this.reverseStatus = 'off';
      } else {
        // 混合
        this.reverseStatus = 'mix';
      }
    },
    // 封装一个“是否全部为 0”的判断方法
    isAllZero(arr) {
      return Array.isArray(arr) && arr.every(item => item.value === '0');
    },

  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

};
</script>

<style scoped>
/* 修改容器为垂直方向的flex布局 */
#container {
  width: 100%;
  height: 100vh;
  background-color: #202022;
  display: flex;
  flex-direction: column;
  /* 改为垂直方向 */
  min-width: 1531px;
  /* 注意：这里去掉了 min-height: 842px */
  overflow: auto;
  user-select: none;
  /* 兼容不同浏览器内核 */
  -webkit-user-select: none;
  /* Chrome/Safari/Edge */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE/Edge 旧版 */
}

/* 头部样式 */
.reclaimed-water-header {
  width: 100%;
  height: 50px;
  flex-shrink: 0;
  background-color: #202022;
  /* 示例背景色，你可以修改 */
  position: absolute;
  top: 0;
  z-index: 100;
  background-image: url('../../../static/img/big/header3.png');
  background-size: 100% 100%;
  display: flex;
}

.reclaimed-water-header-left {
  width: 30%;
  height: 100%;
  position: relative;
}

.reclaimed-water-header-center {
  width: 40%;
  height: 100%;
  font-size: 0.7rem;
  font-weight: 900;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -6px;
}

.reclaimed-water-header-right {
  width: 30%;
  height: 100%;
  position: relative;
}

/* 内容区域容器 - 居中显示内容 */
.reclaimed-water-content {
  width: 1531px;
  height: 842px;
  background-image: url('../../../static/img/big/yidongZS2.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;
  /* 让内容区域在剩余空间中居中 */
  margin: 0 auto;
}

.absolute-content {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 1531px;
  height: 842px;
}

.icon-far {
  position: absolute;
  width: 36px;
  height: 20px;
  z-index: 20;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.icon-far1 {
  position: absolute;
  width: 36px;
  height: 20px;
  z-index: 20;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.blink-simple {
  animation: blinkSimple 1s infinite;
}

@keyframes blinkSimple {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }
}

.police-box {
  position: absolute;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background-color: red;
  z-index: 20;
}

.water-pump-switch {
  position: absolute;
  width: 24px;
  height: 28px;
  z-index: 20;
  background-image: url('../../../static/img/big/bengOpen.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
}

.water-pump-switch.hidden {
  opacity: 0;
  pointer-events: auto;
  /* 关键 */
}

.status-box {
  position: absolute;
  z-index: 20;
  font-size: 15px;
  font-weight: 900;
  writing-mode: vertical-rl;
  /* 兼容旧版浏览器 */
  writing-mode: tb-rl;
}

.status-pump-text {
  position: absolute;
  z-index: 20;
  font-size: 10px;
}

.hyd-box {
  position: absolute;
  z-index: 20;
  font-size: 15px;
  color: #06ff01;
}

.turbidity-box {
  position: absolute;
  z-index: 20;
  font-size: 15px;
  color: #06ff01;
}

.auto-status {
  color: #06ff01;
}

.manual-status {
  color: #ff0000;
}

.pump-status-on {
  background-color: #06ff01;
}

.pump-status-off {
  background-color: #565656;
}

.pump-status-police {
  background-color: #ff0000;
}

.pump-status-box {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  z-index: 20;
}

.header-right-box1 {
  position: absolute;
  z-index: 20;
  color: rgb(144, 144, 144);
  font-size: 0.5rem;
  font-weight: 900;
  top: 21%;
  left: 30%;
  cursor: pointer;
  font-style: italic;
}

.header-right-box2 {
  position: absolute;
  z-index: 20;
  color: rgb(144, 144, 144);
  font-size: 0.5rem;
  font-weight: 900;
  top: 21%;
  left: 72%;
  cursor: pointer;
  font-style: italic;
}


.header-left-box1 {
  position: absolute;
  z-index: 20;
  color: rgb(144, 144, 144);
  font-size: 0.5rem;
  font-weight: 900;
  top: 21%;
  left: 12%;
  cursor: pointer;
  font-style: italic;
}

.header-left-box2 {
  position: absolute;
  z-index: 20;
  color: rgb(144, 144, 144);
  font-size: 0.5rem;
  font-weight: 900;
  top: 21%;
  left: 54%;
  cursor: pointer;
  font-style: italic;
}

/* 只有 active 才是绿色 */
.header-left-box1.active,
.header-left-box2.active {
  color: rgba(0, 232, 46, 0.731)
}

/* 只有 active 才是绿色 */
.header-right-box1.active,
.header-right-box2.active {
  color: rgba(0, 232, 46, 0.731)
}

.status-on {
  color: rgba(0, 232, 46, 0.731);
}

.status-off {
  color: rgba(123, 123, 123, 0.731);
}

.flow-line {
  position: absolute;
  height: 2px;
  /* 线粗 */
  transform-origin: left center;

  /* 一节一节的关键 */
  background-image: repeating-linear-gradient(to right,
      #00ffff 0,
      #00ffff 10px,
      transparent 10px,
      transparent 20px);

  background-size: 20px 100%;
  animation: flowMove 1s linear infinite;
}

@keyframes flowMove {
  from {
    background-position: 0 0;
  }

  to {
    background-position: 20px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/importScreen.vue